import { Accordion, AccordionSummary, AccordionDetails, Typography, Grid } from '@mui/material'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import { Trans, t } from '@lingui/macro'
import DateRangePickerInput from '@/components/ui/inputs/DateRangePickerInput'
import MedicalActsStatsComponent from './charts/MedicalActsStatsComponent'

type MedicalActsSectionProps = {
  isExpanded: boolean
  onChange: (event: React.SyntheticEvent, isExpanded: boolean) => void
  selectedRange: [Date, Date]
  onRangeChange: (range: { start: Date | null; end: Date | null }) => void
  establishmentId: string
  isMobile: boolean
}

export function MedicalActsSection({ isExpanded, onChange, selectedRange, onRangeChange, establishmentId, isMobile }: MedicalActsSectionProps) {
  return (
    <Accordion
      expanded={isExpanded}
      onChange={onChange}
      slotProps={{ transition: { unmountOnExit: false } }}
      sx={{
        '& .MuiAccordionSummary-content': {
          margin: isMobile ? '10px 0' : undefined,
        },
      }}
    >
      <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="medicalActs-content" id="medicalActs-header">
        <Typography variant="h6" sx={{ fontSize: isMobile ? '1rem' : undefined }}>
          <Trans>Medical Acts</Trans>
        </Typography>
      </AccordionSummary>
      <AccordionDetails sx={{ p: isMobile ? 1 : 2 }}>
        <Grid container spacing={isMobile ? 2 : 3}>
          <Grid item xs={12}>
            <DateRangePickerInput
              value={selectedRange}
              onChange={onRangeChange}
              label={t`Select Date Range`}
              sx={{
                width: '100%',
                '& .MuiInputBase-input': {
                  fontSize: isMobile ? '0.875rem' : undefined,
                },
              }}
            />
          </Grid>
          <Grid item xs={12}>
            <MedicalActsStatsComponent establishmentId={establishmentId} startDate={selectedRange[0]} endDate={selectedRange[1]} />
          </Grid>
        </Grid>
      </AccordionDetails>
    </Accordion>
  )
}
